module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-creation2.e820a76e.png" + "?" + Date.now();